var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item"},[_c('div',{staticClass:"label"},[(_vm.isRequired)?_c('b',{staticClass:"icon"}):_vm._e(),_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('div',{staticClass:"box"},[_vm._t("default"),(_vm.validateMessage)?_c('p',[_vm._v(_vm._s(_vm.validateMessage))]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }